import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "note-manage-container" };
import NotePage from "@/components/BlogComponents/NotePage.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'noteReleaseManager',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(NotePage)
            ]));
        };
    }
});
